import {
  WebhookContainer,
  Container,
  Title,
  Section,
  Divider,
  TextUp,
} from "./styles";
import ReactJson from "react-json-view";
import {
  collectDynamicPayload,
  collectGlobalPayload,
  ocurrencePayload,
  ocurrenceUpdatedPayload,
} from "./webhooksPayload";

function JsonView({ src }: { src: object }) {
  return (
    <ReactJson
      src={src}
      collapsed={true}
      enableClipboard={false}
      displayDataTypes={false}
      name={"Payload Enviado"}
      indentWidth={2}
    />
  );
}

export const WebHooks = () => {
  return (
    <WebhookContainer>
      <Title>Webhooks</Title>
      <Divider />
      <Container>
        <label>
          Para utilizar os Webhooks do Retina, é preciso registrar o webhook. O
          registro do webhook pode ser realizado no próprio Retina, seguindo os
          passos abaixo:
          <br />
          <br />
          Meu Perfil &gt; Configurações &gt; Integração &gt; Gatilhos
          <Divider />
          <br />
          <Title>
            Ocorrências
            <TextUp>Gatilhos de ocorrências</TextUp>
          </Title>
          <Divider />
          <Section>
            <h2>
              Ocorrência Criada <TextUp>(OCCURRENCE_CREATED)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma ocorrência é criada</p>
            <br />
            <JsonView src={ocurrencePayload} />
          </Section>
          <Section>
            <h2>
              Ocorrência Atualizada <TextUp>(OCCURRENCE_UPDATED)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma ocorrência é atualizada</p>
            <br />
            <JsonView src={ocurrenceUpdatedPayload} />
          </Section>
          <Section>
            <h2>
              Ocorrência Deletada <TextUp>(OCCURRENCE_DELETED)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma ocorrência é excluída</p>
            <br />
            <JsonView src={ocurrencePayload} />
          </Section>
          <Section>
            <h2>
              Ocorrência Fechada <TextUp>(OCCURRENCE_CLOSED)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma ocorrência é fechada</p>
            <br />
            <JsonView src={ocurrencePayload} />
          </Section>
          <Section>
            <h2>
              Ocorrência Reaberta <TextUp>(OCCURRENCE_REOPENED)</TextUp>
            </h2>
            <br />
            <p>
              Webhook acionado quando uma ocorrência é reaberta ou restaurada
            </p>
            <br />
            <JsonView src={ocurrencePayload} />
          </Section>
          <Divider />
          <br />
          <Title>
            Coletas
            <TextUp>Gatilhos de coletas</TextUp>
          </Title>
          <Divider />
          <Section>
            <h2>
              Coleta de tendência
              <TextUp>(COLLECT_GLOBAL)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma coleta de tendência é recebida</p>
            <br />
            <JsonView src={collectGlobalPayload} />
          </Section>
          <Section>
            <h2>
              Coleta de espectros
              <TextUp>(COLLECT_DYNAMIC)</TextUp>
            </h2>
            <br />
            <p>Webhook acionado quando uma coleta de espectros é recebida</p>
            <br />
            <JsonView src={collectDynamicPayload} />
          </Section>
        </label>
      </Container>
    </WebhookContainer>
  );
};
